function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2609_3826)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 122.406,
  r: 85,
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.977 64.8177L150.987 64.7885H160.173V43.6005C160.173 31.8978 150.66 22.4126 138.928 22.4126C127.194 22.4126 117.684 31.8996 117.684 43.6005C117.684 55.3033 127.196 64.7885 138.928 64.7885H138.932L138.977 64.8177Z",
  fill: "#CC1419"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.929 45.2431C138.567 45.2431 138.275 44.9511 138.275 44.5897V41.3319C138.275 40.9705 138.567 40.6785 138.929 40.6785C139.29 40.6785 139.582 40.9705 139.582 41.3319V44.5897C139.582 44.9511 139.29 45.2431 138.929 45.2431Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.927 48.2966C138.447 48.2966 138.057 47.906 138.057 47.426C138.057 47.1979 138.144 46.977 138.309 46.8128C138.473 46.6467 138.692 46.5554 138.925 46.5554C139.405 46.5554 139.798 46.946 139.798 47.426C139.798 47.906 139.407 48.2966 138.927 48.2966Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M145.599 52.1403H132.259C131.29 52.1403 130.419 51.6402 129.934 50.8007C129.446 49.9629 129.445 48.9591 129.925 48.1177L136.594 36.4442C137.077 35.5955 137.952 35.0881 138.928 35.0881C139.904 35.0881 140.777 35.5955 141.262 36.4442L147.931 48.1177C148.413 48.9591 148.41 49.9629 147.922 50.8007C147.435 51.6384 146.566 52.1403 145.597 52.1403H145.599ZM138.93 36.3968C138.428 36.3968 137.979 36.6577 137.731 37.094L131.06 48.7675C130.812 49.2 130.813 49.7165 131.063 50.1473C131.314 50.578 131.761 50.8353 132.259 50.8353H145.599C146.097 50.8353 146.544 50.578 146.794 50.1473C147.044 49.7165 147.046 49.2 146.8 48.7675L140.131 37.094C139.883 36.6577 139.434 36.3968 138.932 36.3968H138.93Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.065 77.3911H146.792C144.427 77.3911 142.51 79.3081 142.51 81.6729V116.894C142.51 119.259 144.427 121.176 146.792 121.176H200.065C202.43 121.176 204.347 119.259 204.347 116.894V81.6729C204.347 79.3081 202.43 77.3911 200.065 77.3911Z",
  fill: "#1F75DB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.912 121.178V101.742C169.912 101.231 169.58 100.817 169.171 100.817H153.384C152.975 100.817 152.643 101.231 152.643 101.742V121.178H169.91H169.912Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.626 83.8301C174.637 83.8301 174.65 83.8301 174.661 83.8301V77.3928H164.871V83.8301C164.871 86.5331 167.063 88.7251 169.766 88.7251C172.257 88.7251 174.311 86.8652 174.619 84.4579V84.4451C174.645 84.2444 174.659 84.0381 174.659 83.8301H174.625H174.626Z",
  fill: "#1A4E99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.57 109.537H154.842V117.697H155.57V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M157.609 109.537H156.881V117.697H157.609V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.65 109.537H158.922V117.697H159.65V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.689 109.537H160.961V117.697H161.689V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.73 109.537H163.002V117.697H163.73V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.771 109.537H165.043V117.697H165.771V109.537Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.81 109.537H167.082V117.697H167.81V109.537Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2609_3826"
}, /*#__PURE__*/React.createElement("rect", {
  width: 327,
  height: 120,
  fill: "white"
})));

function SvgOutsideCoverageArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 120,
    viewBox: "0 0 327 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgOutsideCoverageArea);
export default __webpack_public_path__ + "static/media/outside-coverage-area.6f3e3c08.svg";
export { ForwardRef as ReactComponent };